export default {
    INPUT: 'input',
    TEXTAREA: 'textarea'
};
